import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"cancel\">\n<title>cancle</title>\n<path d=\"M15.523 6.642v-5.138c0-1.336-1.619-2.008-2.562-1.061l-9.672 9.669c-0.586 0.586-0.586 1.536 0 2.122l9.669 9.669c0.947 0.947 2.562 0.275 2.562-1.061v-5.538c3.434-0.011 9.701-0.382 9.701 8.136 0 4.22-3.316 7.746-7.718 8.561 7.078-0.872 11.648-8.432 11.648-12.931 0.004-10.455-11.055-12.373-13.628-12.427z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol